<template>
  <div class="skeleton__logged-out-header">
    <div
      class="skeleton__logged-out-header__language"
    >
      <Skeleton
        class="skeleton__logged-out-header__language__icon"
        :shape="'circle'"
      />

      <Skeleton class="skeleton__logged-out-header__language__text" />
      <Skeleton class="skeleton__logged-out-header__language__arrow" />
    </div>
    <div
      class="skeleton__logged-out-header__customer"
    >
      <Skeleton
        class="skeleton__logged-out-header__customer__icon"
        :shape="'circle'"
      />

      <Skeleton class="skeleton__logged-out-header__customer__text" />
      <Skeleton class="skeleton__logged-out-header__customer__arrow" />
    </div>
    <div
      class="skeleton__logged-out-header__help"
    >
      <Skeleton
        class="skeleton__logged-out-header__help__icon"
        :shape="'circle'"
      />

      <Skeleton class="skeleton__logged-out-header__help__text" />
    </div>

    <div
      class="skeleton__logged-out-header__profile"
    >
      <Skeleton
        class="skeleton__logged-out-header__profile__icon"
        :shape="'circle'"
      />
      <Skeleton class="skeleton__logged-out-header__profile__text" />
    </div>
  </div>
</template>
<script>
import {Skeleton} from '@progress/kendo-vue-indicators'

export default {
  components: {
    Skeleton
  }
}
</script>
